import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { FormBuilder } from "@angular/forms"
import { MatDialog, MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from "@angular/material"
import { BaseDialogComponent } from "../../../../../base/dialog-base/dialog-base.component"
import { Stringable, StringableValues } from "../../../../../common/stringable.decorator"
import { JSONRpcResponse } from "../../../../../Interfaces/JSONRpcResponse"
import { DialogService, SuiviService } from "../../../../../services"
import { SuiviListing } from "../suivi-listing/suivi-listing.component"
const KEY = 'formulaire-suivi-listing'

@Component({
	selector: 'atyl-formulaire-suivi-listing',
	templateUrl: './formulaire-suivi-listing.component.html',
	styleUrls: ['./formulaire-suivi-listing.component.scss']
})
@Stringable({
	path: "views/partials/content/listing/formulaire-suivi-listing",
	key: KEY,
})
export class FormulaireSuiviListing extends BaseDialogComponent implements OnInit {
    type:string=null;
    ID:number=0;
	formulaire: any
	courrier: any
	document: any
	dossier: any
	_options: any;
	
	suivis = [];
	@StringableValues(KEY) strings: any
	constructor(
		changeDetectorRef: ChangeDetectorRef,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<FormulaireSuiviListing>,
		private suiviService: SuiviService,
		private formBuilder: FormBuilder,
		private _snackBar: MatSnackBar,
		public dialog: MatDialog,
		dialogService: DialogService,
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {

		if (this.data) {
            
            if (this.data.formulaire!=undefined && this.data.formulaire) {
			     this.formulaire = this.data.formulaire;
			     this.type="formulaire";
			     this.ID=this.formulaire.demandeFormulaire.ID;
			 }
			 if (this.data.courrier!=undefined && this.data.courrier) {
                 this.courrier = this.data.courrier;
                 this.type="courrier";
                 this.ID=this.courrier.ID;
             }    
             if (this.data.document!=undefined && this.data.document) {
                 this.document = this.data.document;
                 this.type="document";
                 this.ID=this.document.ID;
             }   
                      
			this.dossier = this.data.dossier
		}
		this._options = {
            
            type: this.type
        }
        if (this.ID>0) {
    		this.suiviService.getSuivisBy(this.ID, this._options).subscribe((res: JSONRpcResponse) => {
    			this.suivis = res.result
    			this.changeDetectorRef.detectChanges()
    		})
    	}

	}
	removeSuiviFrom(suivi: any) {
        
        
		this.suiviService.removeSuiviFrom(this.ID, suivi.ID, this._options).subscribe((res: JSONRpcResponse) => {
			if (res.result) {
				this.suivis = this.suivis.filter(item => item.ID !== suivi.ID)
				this._snackBar.open(res.result.message, "Fermer", {
					duration: 5000,
				})
				this.changeDetectorRef.detectChanges()
			}
		})
	}

	openNewSuiviForm() {
		this.dialogService.closeAll();
		
		let _data={
            action: "attach",
                dataType: "suivi",
                dossier: this.dossier,
            
        };
		switch(this.type) {
           case "courrier":
              _data["courrier"]=this.courrier;
              break;
           case "document":
              _data["document"]=this.document;
              break;  
           default:
               _data["formualire"]=this.formulaire;
            
        }
		
		
		this.dialogService.open(SuiviListing, {
			data: _data,
			draggable: true,
			resizable: true,
		})
	}
}
